import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {Loader, utils, authActions, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormActions, FormBody} = form;
import * as ciselnikActions from "../actions/ciselnikActions";
import ObjectSelect from "../components/ObjectSelect";
import CustomCheckboxField from "../components/CustomCheckboxField";
import SubjektApi from "../api/gen/cgo/SubjektApi";
import {isEmailNotificationsEnabled, isSmsNotificationsEnabled} from "../utils/utils";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro změnu nastavení objednávky uživatele.
 */
class NastaveniObjednavkyUzivatelForm extends Component<WithTranslation> {

    static formName = 'NastaveniObjednavkyUzivatelForm';

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        let {spolecnostId} = this.props;
        const {uzivatelId} = this.props;
        if (!spolecnostId && uzivatelId) {
            SubjektApi.getSpolecnostiUzivatel(uzivatelId, false).then((data) => {
                if (data[0]) {
                    spolecnostId = data[0].id
                }
                this.props.dispatch(ciselnikActions.fetchPobockyUzivatelIfNeeded(spolecnostId ? spolecnostId : null, null));
            });
        } else {
            this.props.dispatch(ciselnikActions.fetchPobockyUzivatelIfNeeded(spolecnostId ? spolecnostId : null, null));
        }
        this.props.dispatch(ciselnikActions.fetchZpusobyDopravyIfNeeded());
        this.props.dispatch(ciselnikActions.fetchZpusobyPlatbyIfNeeded());
    };

    render() {
        const {onClose, submitting, handleSubmit, zpusobyDopravyList, zpusobyPlatbyList, pobockyUzivatelList, authInfo, t} = this.props;

        if (!zpusobyDopravyList.fetched || !zpusobyPlatbyList.fetched || !pobockyUzivatelList.fetched) {
            return <Loader />;
        }

        const emailNotificationsEnabled = isEmailNotificationsEnabled(authInfo);
        const smsNotificationsEnabled = isSmsNotificationsEnabled(authInfo);

        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ObjectSelect
                    label={t('order.default_delivery_method')}
                    name="zpusobDopravaVychozi"
                    items={zpusobyDopravyList.rows}
                    getItemValue={(item) => item ? item.nazevDoprava : ""}
                    disabled={submitting}
                    showEmpty={true}
                />
                <ObjectSelect
                    label={t('order.default_payment_method')}
                    name="zpusobPlatbaVychozi"
                    items={zpusobyPlatbyList.rows}
                    getItemValue={(item) => item ? item.nazevZpusobPlatba : ""}
                    disabled={submitting}
                    showEmpty={true}
                />
                <ObjectSelect
                    label={t('order.default_dispensing_branch')}
                    name="pobockaVydejVychozi"
                    items={pobockyUzivatelList.rows}
                    getItemValue={(item) => item ? item.nazevPobocka : ""}
                    disabled={submitting}
                    showEmpty={true}
                />
                {emailNotificationsEnabled && <CustomCheckboxField label={t('order.send_notification_email')} name="notifikaceEmail" disabled={submitting} />}
                {smsNotificationsEnabled && <CustomCheckboxField label={t('order.send_notification_sms')} name="notifikaceSms" disabled={submitting} />}
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting} />
        </Form>
    }
}

function mapStateToProps(state) {
    return {
        authInfo: utils.storeFromArea(state, authActions.AUTH_INFO_AREA),
        zpusobyDopravyList: utils.storeFromArea(state, ciselnikActions.ZPUSOBY_DOPRAVY_LIST_AREA),
        zpusobyPlatbyList: utils.storeFromArea(state, ciselnikActions.ZPUSOBY_PLATBY_LIST_AREA),
        pobockyUzivatelList: utils.storeFromArea(state, ciselnikActions.POBOCKY_UZIVATEL_LIST_AREA)
    }
}

export default withTranslation()(connect(mapStateToProps)(reduxForm({
    form: NastaveniObjednavkyUzivatelForm.formName,
})(NastaveniObjednavkyUzivatelForm)));
